"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedirectAuthManager = void 0;
var utils_1 = require("./utils");
exports.RedirectAuthManager = {
    connect: {
        createUrlRequestConnectToPass: utils_1.createUrlRequestConnectToPass,
        getResponsePassToConnect: utils_1.getResponsePassToConnect,
        cleanResponsePassToConnect: utils_1.cleanResponsePassToConnect,
    },
    pass: {
        getRequestConnectToPass: utils_1.getRequestConnectToPass,
        createUrlRequestPassToWallet: utils_1.createUrlRequestPassToWallet,
        getResponseWalletToPass: utils_1.getResponseWalletToPass,
        cleanResponseWalletToPass: utils_1.cleanResponseWalletToPass,
        createUrlResponsePassToConnect: utils_1.createUrlResponsePassToConnect,
    },
    wallet: {
        getRequestPassToWallet: utils_1.getRequestPassToWallet,
        createUrlResponseWalletToPass: utils_1.createUrlResponseWalletToPass,
        createUrlResponseWalletToPassOrConnect: utils_1.createUrlResponseWalletToPassOrConnect,
    },
};
